export class CourseProgram {
  constructor() {}
  CourseName: string = '';
  Description: string = '';
  LearningArea: number = 0;
  Materials: string = '';
  CourseType: number = 0;
  PublishingDate: string = '';
  CourseCategory: number = 0;
  Program: string = '';
  Aims: string = '';
  ProductCode: string = '';
  Division: number = 0;
  CourseLanguage: string = '';
  Countries: string = '';
  ExtendProgram: string = '';
  SubCourses: CourseProgram[];
  TrainingPlan: boolean = false;
  CourseImage: string = "";
}

export enum LearningAreasString{
    "AREA33619968"= "Configurazione e Setup",
    "AREA33619969"= "Amministrativa",
    "AREA33619970"= "Commerciale",
    "AREA33619971"= "Magazzino",
    "AREA33619972"= "Produzione",
    "AREA33619973"= "Strumenti per Monitorare",
    "AREA33619974"= "Strumenti per Migliorare",
    "AREA33619975"= "Strumenti per Integrare",
    "AREA33619976"= "Marketing e Commerciale",
    "AREA33619977"= "Consulenza",
    "AREA33619978"= "Sistemi Operativi e Reti",
    "AREA33619979"= "DataBase",
    "AREA33619980"= "Microsoft Back Office",
    "AREA33619981"= "Enterprise XP",
    "AREA33619982"= "Verticali",
    "AREA33619983"= "Internal",
    "AREA33619984"= "Altro",
    "AREA33619985"= "Non definito",
    "AREA33619986"= "Store Management",
    "AREA33619987"= "Manufacturing",
    "AREA33619988"= "Package Area Sviluppo"
}

export enum LearningAreasFolders{
    Configurazione_E_Setup = 33619968,
    Amministrativa = 33619969,
    Commerciale = 33619970,
    Magazzino = 33619971,
    Produzione = 33619972,
    Strumenti_Per_Monitorare = 33619973,
    Strumenti_Per_Migliorare = 33619974,
    Strumenti_Per_Integrare = 33619975,
    Marketing_E_Commerciale = 33619976,
    Consulenza = 33619977,
    SistemiOperativi_E_Reti = 33619978,
    DataBase = 33619979,
    Microsoft_Back_Office = 33619980,
    Enterprise_XP = 33619981,
    Verticali = 33619982,
    Interni = 33619983,
    Altro = 33619984,
    Non_definito = 33619985,
    Store_Management = 33619986,
    Manufacturing = 33619987,
    PackageAreaSviluppo = 33619988
}

export enum CourseProductCodes{
    "TBS" = "Task Builder Studio Personal & Professional Edition",
    "IMS" = "Integration Management System",
    "MAGO.NET" = "Mago.Net",
    "MAGO4" = "Mago4",
    "MAGOCLD" = "MagoCloud",
    "IMAGO" = "I.Mago",
    "RETAIL" = "Store Management"
}

export enum CourseLanguages{
    "DE" = "GERMAN",
    "IT" = "ITALIAN",
    "EN" = "ENGLISH",
    "RO" = "ROMANIAN"
}

export enum CourseUserLanguage{
    "de-DE" = "GERMAN",
    "it-IT" = "ITALIAN",
    "en-EN" = "ENGLISH",
    "en-US" = "ENGLISH",
    "ro-RO" = "ROMANIAN"
}

export class CourseFilters{
  searchString: string;
  courseArea: string;
  courseProduct: string;
  courseLanguage: string;
}
